import { useAppConfig } from "~/app/config/useAppConfig";
import { Button } from "~/common/mui";
import { isProductPMA } from "~/domains/product/utils/productDescriptorUtils";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { useTranslation } from "react-i18next";
import { userIsCustomer, userIsSalesman } from "~/domains/user/utils/roles";
import DescriptionIcon from "@mui/icons-material/Description";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export const AtcCloseButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant={"text"}
      onClick={onClick}
      sx={{
        flexShrink: 0,
      }}
    >
      {t("cancel")}
    </Button>
  );
};

export const AtcPrimaryAction = ({
  onClick,
  descriptor,
  disabled,
  fullWidth,
  loading,
}: {
  onClick?: () => void;
  descriptor: ProductDescriptor;
  disabled?: boolean;
  fullWidth: boolean;
  loading?: boolean;
}) => {
  const { t } = useTranslation();
  const webservicesDisabled = useAppConfig()?.configuration.disableAllWS ?? false;
  const isDisabled = webservicesDisabled ?? disabled;

  let icon;
  let label;
  if (userIsSalesman()) {
    label = "basket.addToQuote";
    icon = <DescriptionIcon />;
  } else if (userIsCustomer() && isProductPMA(descriptor)) {
    label = "cartPage.btn.quote";
    icon = <DescriptionIcon />;
  } else {
    label = "addToCartPopup.add.submitBtn";
    icon = <ShoppingCartIcon />;
  }

  return (
    <Button
      onClick={onClick}
      loading={loading}
      size={"medium"}
      startIcon={icon}
      disabled={isDisabled}
      data-test-id={"add-to-cart-btn-ok"}
      fullWidth={fullWidth}
    >
      {t(label)}
    </Button>
  );
};
